import React, { useEffect, useState } from 'react';
import type { FC } from 'react';
import cookies from 'js-cookie';
import { Typography } from '@alfalab/core-components-typography';
import { Button } from '@alfalab/core-components-button';
import { Link } from '@alfalab/core-components-link';

import type { TAlfaleasingCookieBannerV2 } from './models';

export const AlfaleasingCookieBannerV2: FC<TAlfaleasingCookieBannerV2> = ({
    cookieName = 'al_privacy_cookie',
    expires = 365,
    styles,
}) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const cookie = cookies.get(cookieName);

        if (!cookie) {
            setShow(true);
        }
    }, [cookieName]);

    const hidePopup = () => {
        cookies.set(cookieName, 'true', { expires });

        setShow(false);
    };

    if (!show) {
        return null;
    }

    return (
        <div className={styles.rootBanner}>
            <div className={styles.inner}>
                <Typography.Text className={styles.text} tag="div" view="primary-medium">
                    {
                        'Мы обрабатываем cookie с целью персонализации сервисов и улучшения работы сайта. '
                    }
                    <Link
                        href="/zashchita-personalnykh-dannykh/"
                        rel="noreferrer"
                        target="_blank"
                        view="secondary"
                    >
                        Узнать подробнее
                    </Link>
                </Typography.Text>
                <Button className={styles.button} onClick={hidePopup} size="xs" view="primary">
                    <Typography.Text view="primary-medium" weight="medium">
                        Принять
                    </Typography.Text>
                </Button>
            </div>
        </div>
    );
};
